export enum FormDataSteps {
  layout = 'layout',
  provider = 'provider',
  movimentationType = 'movimentationType',
  templateDownloaded = 'templateDownloaded',
  files = 'files',
  attachment = 'attachment',
}
